import React, { useState, useEffect, useCallback } from 'react';
import '../styles/PricingAdmin.css';
import { apiFetch, apiPost } from '../api';

const PLAN_COLORS = {
  ca_starter:        '#7B9BB8',
  ca_growth:         '#00B4D8',
  ca_growth_pro:     '#F4B942',
  client_starter:    '#6C8EBF',
  client_growth:     '#2ECC71',
  client_growth_pro: '#9B59B6',
};

const DEFAULT_PLANS = [
  { plan_code: 'ca_starter',        plan_name: 'CA Starter',        plan_type: 'ca',     price_monthly_rate: 149,  price_annual_rate: 124,  price_monthly_bulk: 119,  price_annual_bulk: 99,   bulk_threshold: 50,      billing_unit: 'per_client',   duration_unit: 'per client / month',   trial_days: 30, max_clients: null, min_clients: 5, max_team_members: 1,    featured: false, cta_label: 'Start free trial →', cta_style: 'outline', caption: 'Everything you need to start auditing. Pay for 10 months, get 12.',                          rule_list_json: ['30-day free trial — unlimited clients','Unlimited client audits','Single CA user','Tally Bridge Connector','Tally Dashboard','AI Powered Audit Report'],                                                                                     rule_list_disabled_json: ['CA team members','Customer Workflow','Audit report download','Confidence Score per AI recommendation','Automatic Reconciliation — Bank, GSTR-2A & 2B','GST filing','Intelligent Assistant Chatbot'], features_json: { clients: { enabled: true }, ai_chatbot: { enabled: false }, ai_reports: { enabled: true }, gst_filing: { enabled: false }, tally_sync: { enabled: true }, team_members: { limit: 1, enabled: false }, client_portal: { enabled: false }, reconciliation: { enabled: false }, report_download: { enabled: false }, confidence_score: { enabled: false } } },
  { plan_code: 'ca_growth',         plan_name: 'CA Growth',         plan_type: 'ca',     price_monthly_rate: 299,  price_annual_rate: 249,  price_monthly_bulk: 239,  price_annual_bulk: 199,  bulk_threshold: 50,      billing_unit: 'per_client',   duration_unit: 'per client / month',   trial_days: 30, max_clients: null, min_clients: 5, max_team_members: 25,   featured: true,  cta_label: 'Start free trial →', cta_style: 'blue',    caption: 'Scale your practice with team, workflow and reconciliation. Pay for 10, get 12.',            rule_list_json: ['30-day free trial — unlimited clients','Everything in CA Starter','Up to 25 team members','Customer Workflow','Audit report download','Confidence Score per AI recommendation','Automatic Reconciliation — Bank, GSTR-2A & 2B','GST filing'], rule_list_disabled_json: ['Intelligent Assistant Chatbot'],                                                                                                                   features_json: { clients: { enabled: true }, ai_chatbot: { enabled: false }, ai_reports: { enabled: true }, gst_filing: { enabled: true  }, tally_sync: { enabled: true }, team_members: { limit: 25, enabled: true  }, client_portal: { enabled: true  }, reconciliation: { enabled: true  }, report_download: { enabled: true  }, confidence_score: { enabled: true  } } },
  { plan_code: 'ca_growth_pro',     plan_name: 'CA Growth Pro',     plan_type: 'ca',     price_monthly_rate: 399,  price_annual_rate: 349,  price_monthly_bulk: 319,  price_annual_bulk: 265,  bulk_threshold: 50,      billing_unit: 'per_client',   duration_unit: 'per client / month',   trial_days: 30, max_clients: null, min_clients: 5, max_team_members: null,  featured: false, cta_label: 'Start free trial →', cta_style: 'dark',    caption: 'Full platform — unlimited team, AI assistant. Pay for 10, get 12.',                          rule_list_json: ['30-day free trial — unlimited clients','Everything in CA Growth','Unlimited team members','Intelligent Assistant Chatbot'],                                                                                                                       rule_list_disabled_json: [],                                                                                                                                                                                              features_json: { clients: { enabled: true }, ai_chatbot: { enabled: true  }, ai_reports: { enabled: true }, gst_filing: { enabled: true  }, tally_sync: { enabled: true }, team_members: { enabled: true  },            client_portal: { enabled: true  }, reconciliation: { enabled: true  }, report_download: { enabled: true  }, confidence_score: { enabled: true  } } },
  { plan_code: 'client_starter',    plan_name: 'Client Starter',    plan_type: 'client', price_monthly_rate: 249,  price_annual_rate: 219,  price_monthly_bulk: 249,  price_annual_bulk: 219,  bulk_threshold: 999999,  billing_unit: 'per_company',  duration_unit: 'per company / month',  trial_days: 30, max_clients: 1,    min_clients: 1, max_team_members: 1,    featured: false, cta_label: 'Start free trial →', cta_style: 'outline', caption: 'Always-on GST & TDS compliance for one company. Pay for 10, get 12.',                        rule_list_json: ['30-day free trial','Complete compliance for one company','Single user','Tally Bridge Connector','Tally Dashboard','AI Powered Audit Report','Audit report download'],                                                                            rule_list_disabled_json: ['Team members','Confidence Score per AI recommendation','Automatic Reconciliation — Bank, GSTR-2A & 2B','GST filing','Intelligent Assistant Chatbot'],                                          features_json: { clients: { limit: 1, enabled: true }, ai_chatbot: { enabled: false }, ai_reports: { enabled: true }, gst_filing: { enabled: false }, tally_sync: { enabled: true }, team_members: { limit: 1, enabled: false }, client_portal: { enabled: false }, reconciliation: { enabled: false }, report_download: { enabled: true  }, confidence_score: { enabled: false } } },
  { plan_code: 'client_growth',     plan_name: 'Client Growth',     plan_type: 'client', price_monthly_rate: 349,  price_annual_rate: 299,  price_monthly_bulk: 349,  price_annual_bulk: 299,  bulk_threshold: 999999,  billing_unit: 'per_company',  duration_unit: 'per company / month',  trial_days: 30, max_clients: null, min_clients: 1, max_team_members: 25,   featured: true,  cta_label: 'Start free trial →', cta_style: 'blue',    caption: 'For in-house accounting teams that need collaboration and reconciliation.',                  rule_list_json: ['30-day free trial','Everything in Client Starter','Up to 25 team members','Confidence Score per AI recommendation','Automatic Reconciliation — Bank, GSTR-2A & 2B','GST filing'],                        rule_list_disabled_json: ['Intelligent Assistant Chatbot'],                                                                                                                                                               features_json: { clients: { enabled: true }, ai_chatbot: { enabled: false }, ai_reports: { enabled: true }, gst_filing: { enabled: true  }, tally_sync: { enabled: true }, team_members: { limit: 25, enabled: true  }, client_portal: { enabled: false }, reconciliation: { enabled: true  }, report_download: { enabled: true  }, confidence_score: { enabled: true  } } },
  { plan_code: 'client_growth_pro', plan_name: 'Client Growth Pro', plan_type: 'client', price_monthly_rate: 499,  price_annual_rate: 399,  price_monthly_bulk: 499,  price_annual_bulk: 399,  bulk_threshold: 999999,  billing_unit: 'per_company',  duration_unit: 'per company / month',  trial_days: 30, max_clients: null, min_clients: 1, max_team_members: null,  featured: false, cta_label: 'Start free trial →', cta_style: 'dark',    caption: 'Unlimited team, AI assistant over your Tally data. Pay for 10, get 12.',                     rule_list_json: ['30-day free trial','Everything in Client Growth','Unlimited team members','Intelligent Assistant Chatbot'],                                                                                               rule_list_disabled_json: [],                                                                                                                                                                                              features_json: { clients: { enabled: true }, ai_chatbot: { enabled: true  }, ai_reports: { enabled: true }, gst_filing: { enabled: true  }, tally_sync: { enabled: true }, team_members: { enabled: true  },            client_portal: { enabled: false }, reconciliation: { enabled: true  }, report_download: { enabled: true  }, confidence_score: { enabled: true  } } },
];

const FEATURE_KEYS = [
  { key: 'tally_sync',       label: 'Tally Sync'       },
  { key: 'ai_reports',       label: 'AI Reports'       },
  { key: 'client_portal',    label: 'Client Portal'    },
  { key: 'team_members',     label: 'Team Members'     },
  { key: 'report_download',  label: 'Report Download'  },
  { key: 'confidence_score', label: 'Confidence Score' },
  { key: 'reconciliation',   label: 'Reconciliation'   },
  { key: 'gst_filing',       label: 'GST Filing'       },
  { key: 'ai_chatbot',       label: 'AI Chatbot'       },
];

function readFeature(featuresJson, key) {
  const val = featuresJson?.[key];
  if (val == null) return false;
  if (typeof val === 'boolean') return val;
  return val.enabled === true;
}

function writeFeature(featuresJson, key, enabled) {
  const existing = featuresJson?.[key];
  const rest = (existing && typeof existing === 'object') ? existing : {};
  return { ...featuresJson, [key]: { ...rest, enabled } };
}

function fmt(n) { return `₹${Number(n).toLocaleString('en-IN')}`; }

function useDebounce(value, delay = 400) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);
  return debouncedValue;
}

function FeatureListEditor({ items, onChange, type }) {
  const [newText, setNewText] = useState('');
  const color = type === 'included' ? 'var(--green)' : 'var(--text3)';

  const add = () => {
    const t = newText.trim();
    if (!t) return;
    onChange([...items, t]);
    setNewText('');
  };
  const remove = (i) => onChange(items.filter((_, idx) => idx !== i));
  const moveUp = (i) => {
    if (i === 0) return;
    const arr = [...items];
    [arr[i - 1], arr[i]] = [arr[i], arr[i - 1]];
    onChange(arr);
  };
  const edit = (i, val) => {
    const arr = [...items];
    arr[i] = val;
    onChange(arr);
  };

  return (
    <div>
      <div className="pa-feat-list">
        {items.map((item, i) => (
          <div className="pa-feat-row" key={i}>
            <span
              className="pa-feat-badge"
              style={{
                background: type === 'included' ? 'rgba(46,204,113,0.12)' : 'rgba(90,122,153,0.15)',
                color,
              }}
            >
              {type === 'included' ? '✓' : '—'}
            </span>
            <input className="pa-feat-input" value={item} onChange={e => edit(i, e.target.value)} />
            <button className="pa-icon-btn up" onClick={() => moveUp(i)} title="Move up">↑</button>
            <button className="pa-icon-btn danger" onClick={() => remove(i)} title="Remove">×</button>
          </div>
        ))}
      </div>
      <div className="pa-add-feat-row">
        <input
          className="pa-add-feat-input"
          placeholder={`Add ${type} feature…`}
          value={newText}
          onChange={e => setNewText(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && add()}
        />
        <button className={`pa-add-btn ${type}`} onClick={add} disabled={!newText.trim()}>
          + Add
        </button>
      </div>
    </div>
  );
}

function PlanEditor({ plan, onChange }) {
  const set = (field, value) => onChange({ ...plan, [field]: value });
  const setFeat = (key, enabled) => onChange({
    ...plan,
    features_json: writeFeature(plan.features_json, key, enabled),
  });

  const isBulkEnabled = plan.bulk_threshold < 999999;
  const savePct = plan.price_monthly_rate
    ? Math.round((1 - plan.price_annual_rate / plan.price_monthly_rate) * 100)
    : 0;

  return (
    <div>
      <div className="pa-preview" style={{ marginBottom: 24 }}>
        {[
          { val: fmt(plan.price_monthly_rate),  lbl: 'Monthly / unit' },
          { val: fmt(plan.price_annual_rate),    lbl: `Annual / unit (${savePct}% off)` },
          { val: plan.bulk_threshold < 999999 ? fmt(plan.price_monthly_bulk) : '—', lbl: `Bulk monthly (>${plan.bulk_threshold})` },
          { val: plan.bulk_threshold < 999999 ? fmt(plan.price_annual_bulk)  : '—', lbl: `Bulk annual (>${plan.bulk_threshold})`  },
        ].map(p => (
          <div className="pa-preview-pill" key={p.lbl}>
            <span className="pa-preview-val">{p.val}</span>
            <span className="pa-preview-lbl">{p.lbl}</span>
          </div>
        ))}
      </div>

      <div className="pa-card">
        <div className="pa-card-title">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
          Pricing
        </div>
        <div className="pa-field-grid" style={{ marginBottom: 14 }}>
          <div className="pa-field">
            <label className="pa-label">Monthly rate <span>₹ / unit</span></label>
            <input className="pa-input" type="number" value={plan.price_monthly_rate || ''}
              onChange={e => set('price_monthly_rate', +e.target.value)} />
          </div>
          <div className="pa-field">
            <label className="pa-label">Annual rate <span>₹ / unit / mo</span></label>
            <input className="pa-input" type="number" value={plan.price_annual_rate || ''}
              onChange={e => set('price_annual_rate', +e.target.value)} />
          </div>
          <div className="pa-field">
            <label className="pa-label">Trial days</label>
            <input className="pa-input" type="number" value={plan.trial_days || 30}
              onChange={e => set('trial_days', +e.target.value)} />
          </div>
        </div>

        <div className="pa-toggle-check-row">
          <label className="pa-toggle">
            <input type="checkbox" checked={isBulkEnabled}
              onChange={e => set('bulk_threshold', e.target.checked ? 50 : 999999)} />
            <span className="pa-toggle-slider" />
          </label>
          <span className="pa-toggle-text">Volume discount (bulk pricing)</span>
        </div>

        {isBulkEnabled && (
          <div className="pa-field-grid">
            <div className="pa-field">
              <label className="pa-label">Bulk threshold <span>seats</span></label>
              <input className="pa-input" type="number" value={plan.bulk_threshold}
                onChange={e => set('bulk_threshold', +e.target.value)} />
            </div>
            <div className="pa-field">
              <label className="pa-label">Bulk monthly <span>₹ / unit</span></label>
              <input className="pa-input" type="number" value={plan.price_monthly_bulk || ''}
                onChange={e => set('price_monthly_bulk', +e.target.value)} />
            </div>
            <div className="pa-field">
              <label className="pa-label">Bulk annual <span>₹ / unit / mo</span></label>
              <input className="pa-input" type="number" value={plan.price_annual_bulk || ''}
                onChange={e => set('price_annual_bulk', +e.target.value)} />
            </div>
          </div>
        )}
      </div>

      <div className="pa-card">
        <div className="pa-card-title">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" /></svg>
          Plan Details
        </div>
        <div className="pa-field-grid-2" style={{ marginBottom: 14 }}>
          <div className="pa-field">
            <label className="pa-label">Display name</label>
            <input className="pa-input" value={plan.plan_name} onChange={e => set('plan_name', e.target.value)} />
          </div>
          <div className="pa-field">
            <label className="pa-label">CTA button label</label>
            <input className="pa-input" value={plan.cta_label || ''} onChange={e => set('cta_label', e.target.value)} />
          </div>
        </div>
        <div className="pa-field" style={{ marginBottom: 14 }}>
          <label className="pa-label">Caption <span>shown under plan name</span></label>
          <textarea className="pa-textarea" value={plan.caption}
            onChange={e => set('caption', e.target.value)} rows={2} />
        </div>
        <div className="pa-field-grid" style={{ marginBottom: 14 }}>
          <div className="pa-field">
            <label className="pa-label">CTA style</label>
            <select className="pa-select" value={plan.cta_style} onChange={e => set('cta_style', e.target.value)}>
              <option value="outline">Outline (grey)</option>
              <option value="blue">Blue (primary)</option>
              <option value="dark">Dark (premium)</option>
            </select>
          </div>
          <div className="pa-field">
            <label className="pa-label">Billing unit</label>
            <select className="pa-select" value={plan.billing_unit} onChange={e => set('billing_unit', e.target.value)}>
              <option value="per_client">Per client</option>
              <option value="per_company">Per company</option>
              <option value="flat">Flat</option>
            </select>
          </div>
          <div className="pa-field">
            <label className="pa-label">Max team members <span>blank = unlimited</span></label>
            <input className="pa-input" type="number"
              value={plan.max_team_members ?? ''}
              placeholder="Unlimited"
              onChange={e => set('max_team_members', e.target.value === '' ? null : +e.target.value)} />
          </div>
        </div>
        <div className="pa-toggle-row">
          <span className="pa-toggle-label">Featured plan (highlighted in pricing UI)</span>
          <label className="pa-toggle">
            <input type="checkbox" checked={plan.featured} onChange={e => set('featured', e.target.checked)} />
            <span className="pa-toggle-slider" />
          </label>
        </div>
      </div>

      <div className="pa-card">
        <div className="pa-card-title">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></svg>
          Feature Gates
          <span className="pa-card-note">— controls backend access enforcement</span>
        </div>
        {FEATURE_KEYS.map(f => (
          <div className="pa-toggle-row" key={f.key}>
            <div>
              <span className="pa-toggle-label">{f.label}</span>
              {typeof plan.features_json?.[f.key] === 'object' &&
               plan.features_json[f.key]?.limit != null && (
                <span className="pa-feat-limit">(limit: {plan.features_json[f.key].limit})</span>
              )}
            </div>
            <label className="pa-toggle">
              <input type="checkbox"
                checked={readFeature(plan.features_json, f.key)}
                onChange={e => setFeat(f.key, e.target.checked)} />
              <span className="pa-toggle-slider" />
            </label>
          </div>
        ))}
      </div>

      <div className="pa-card">
        <div className="pa-card-title">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="20 6 9 17 4 12" /></svg>
          Included Features
          <span className="pa-card-note">— shown with ✓ on pricing cards</span>
        </div>
        <FeatureListEditor
          items={plan.rule_list_json || []}
          onChange={val => onChange({ ...plan, rule_list_json: val })}
          type="included"
        />
      </div>

      <div className="pa-card">
        <div className="pa-card-title">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
          Not Included
          <span className="pa-card-note">— shown with — on pricing cards</span>
        </div>
        <FeatureListEditor
          items={plan.rule_list_disabled_json || []}
          onChange={val => onChange({ ...plan, rule_list_disabled_json: val })}
          type="excluded"
        />
      </div>
    </div>
  );
}

function SubscriptionsTab() {
  const [subs,    setSubs]    = useState([]);
  const [loading, setLoading] = useState(true);
  const [search,  setSearch]  = useState('');

  useEffect(() => {
    apiFetch('/subscriptions/all')
      .then(data => setSubs(data || []))
      .catch(() => setSubs([]))
      .finally(() => setLoading(false));
  }, []);

  const filtered = subs.filter(s =>
    !search ||
    s.user_email?.toLowerCase().includes(search.toLowerCase()) ||
    s.plan_name?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="pa-subs-wrap">
      <div className="pa-subs-search-row">
        <input
          className="pa-input"
          style={{ maxWidth: 320 }}
          placeholder="Search by email or plan…"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        <span className="pa-header-note">
          {filtered.length} subscription{filtered.length !== 1 ? 's' : ''}
        </span>
      </div>

      {loading ? (
        <div className="pa-subs-loading">Loading…</div>
      ) : (
        <div>
          <div className="pa-history-row header">
            <span>Email</span><span>Plan</span><span>Status</span><span>Started</span>
          </div>
          {filtered.length === 0 ? (
            <div className="pa-subs-empty">No subscriptions found.</div>
          ) : filtered.map(s => (
            <div className="pa-history-row" key={s.id}>
              <span className="pa-row-email">{s.user_email || s.user_id}</span>
              <span className="pa-row-plan">{s.plan_name}</span>
              <span><span className={`pa-status-badge ${s.status}`}>{s.status}</span></span>
              <span className="pa-row-date">
                {s.started_at
                  ? new Date(s.started_at).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })
                  : '—'}
                {s.expires_at && (
                  <span className="pa-row-expires">
                    expires {new Date(s.expires_at).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' })}
                  </span>
                )}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function PricingAdmin({ userRole }) {
  const [plans,     setPlans]     = useState(DEFAULT_PLANS);
  const [origPlans, setOrigPlans] = useState(DEFAULT_PLANS);
  const [selected,  setSelected]  = useState('ca_starter');
  const [tab,       setTab]       = useState('plans');
  const [saving,    setSaving]    = useState(false);
  const [toast,     setToast]     = useState(null);
  const [loaded,    setLoaded]    = useState(false);

  const isAdmin = userRole?.isAdmin ?? false;

  useEffect(() => {
    if (!isAdmin) return;
    apiFetch('/subscriptions/plans')
      .then(data => {
        if (data?.length) { setPlans(data); setOrigPlans(data); }
        setLoaded(true);
      })
      .catch(() => setLoaded(true));
  }, [isAdmin]);

  if (!isAdmin) {
    return (
      <div style={{ padding: 40, color: 'var(--text3)', fontFamily: 'var(--sans)' }}>
        Admin access required.
      </div>
    );
  }

  const showToast = (msg, type = 'success') => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3000);
  };

  const isDirty = JSON.stringify(plans) !== JSON.stringify(origPlans);
  const currentPlan = plans.find(p => p.plan_code === selected) || plans[0];

  const updatePlan = useCallback((updated) => {
    setPlans(prev => prev.map(p => p.plan_code === updated.plan_code ? updated : p));
  }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
      const modified = plans.filter((p, i) => JSON.stringify(p) !== JSON.stringify(origPlans[i]));
      await Promise.all(
        modified.map(p =>
          apiPost(`/subscriptions/plans/${p.plan_code}`, {
            plan_name: p.plan_name,
            price_monthly_rate: p.price_monthly_rate,
            price_annual_rate:  p.price_annual_rate,
            price_monthly_bulk: p.price_monthly_bulk,
            price_annual_bulk:  p.price_annual_bulk,
            bulk_threshold:     p.bulk_threshold,
            trial_days:         p.trial_days,
            cta_label:          p.cta_label,
            cta_style:          p.cta_style,
            featured:           p.featured,
            caption:            p.caption,
            max_clients:        p.max_clients,
            min_clients:        p.min_clients,
            max_team_members:   p.max_team_members,
            features_json:           p.features_json,
            rule_list_json:          p.rule_list_json,
            rule_list_disabled_json: p.rule_list_disabled_json,
            sort_order:              p.sort_order,
          })
        )
      );
      setOrigPlans([...plans]);
      showToast(`${modified.length} plan${modified.length !== 1 ? 's' : ''} saved successfully`);
    } catch (err) {
      showToast(err.message || 'Save failed', 'error');
    } finally {
      setSaving(false);
    }
  };

  const handleReset = () => {
    setPlans([...origPlans]);
    showToast('Changes discarded');
  };

  return (
    <>
      <div className="pa-root">
        <div className="pa-header">
          <div className="pa-header-left">
            <div className="pa-header-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                <path d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div>
              <div className="pa-header-title">Pricing Admin</div>
              <div className="pa-header-sub">AuditPrOS · Subscription Plan Configurator</div>
            </div>
          </div>
          <div className="pa-header-right">
            {isDirty && <span className="pa-badge">Unsaved changes</span>}
            <span className="pa-header-note">
              {loaded ? `${plans.length} plans loaded` : 'Loading…'}
            </span>
          </div>
        </div>

        <div className="pa-tabs">
          {[
            { id: 'plans',         label: 'Plan Configurator'    },
            { id: 'subscriptions', label: 'Active Subscriptions' },
          ].map(t => (
            <button
              key={t.id}
              className={`pa-tab${tab === t.id ? ' active' : ''}`}
              onClick={() => setTab(t.id)}
            >
              {t.label}
            </button>
          ))}
        </div>

        {tab === 'subscriptions' ? <SubscriptionsTab /> : (
          <div className="pa-body">
            <div className="pa-sidebar">
              {['ca', 'client'].map(type => (
                <div key={type}>
                  <div className="pa-plan-type-header">
                    {type === 'ca' ? 'CA Plans' : 'Client / MSME Plans'}
                  </div>
                  {plans.filter(p => p.plan_type === type).map(p => {
                    const color = PLAN_COLORS[p.plan_code] || '#7B9BB8';
                    const isModified = JSON.stringify(p) !== JSON.stringify(origPlans.find(o => o.plan_code === p.plan_code));
                    return (
                      <div
                        key={p.plan_code}
                        className={`pa-plan-item${selected === p.plan_code ? ' active' : ''}`}
                        onClick={() => setSelected(p.plan_code)}
                      >
                        <div className="pa-plan-dot" style={{ background: color }} />
                        <div className="pa-plan-name-wrap">
                          <div className="pa-plan-label">
                            {p.plan_name}
                            {isModified && <span className="pa-modified-dot">●</span>}
                          </div>
                          <div className="pa-plan-sub">
                            ₹{p.price_monthly_rate}/mo · ₹{p.price_annual_rate}/mo annual
                          </div>
                        </div>
                        {p.featured && <span className="pa-featured-star">★</span>}
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>

            <div className="pa-main">
              {currentPlan && (
                <>
                  <div className="pa-editor-header">
                    <div
                      className="pa-editor-dot"
                      style={{ background: PLAN_COLORS[currentPlan.plan_code] || '#7B9BB8' }}
                    />
                    <h2 className="pa-editor-title">{currentPlan.plan_name}</h2>
                    <span className="pa-editor-badge">{currentPlan.plan_code}</span>
                    <span className="pa-editor-type">{currentPlan.plan_type}</span>
                  </div>
                  <PlanEditor plan={currentPlan} onChange={updatePlan} />
                </>
              )}
            </div>
          </div>
        )}

        {tab === 'plans' && (
          <div className="pa-action-bar">
            <span className={`pa-action-left${isDirty ? ' dirty' : ''}`}>
              {isDirty
                ? '● Unsaved changes — save to push to live pricing'
                : '✓ All plans in sync with database'}
            </span>
            <div className="pa-action-btns">
              <button className="pa-btn pa-btn-ghost" onClick={handleReset} disabled={!isDirty || saving}>
                Discard changes
              </button>
              <button className="pa-btn pa-btn-primary" onClick={handleSave} disabled={!isDirty || saving}>
                {saving
                  ? 'Saving…'
                  : `Save plan${plans.filter((p, i) => JSON.stringify(p) !== JSON.stringify(origPlans[i])).length > 1 ? 's' : ''}`}
              </button>
            </div>
          </div>
        )}

        {toast && <div className={`pa-toast ${toast.type}`}>{toast.msg}</div>}
      </div>
    </>
  );
}
